<div class="google-tfa">
  <p class="google-tfa__title">{{ 'WM_TECH_POOL.SETTINGS.TFA_TITLE' | translate }}</p>

  <div class="google-tfa__block">
    <p class="google-tfa__subtitle">{{ 'WM_TECH_POOL.SETTINGS.GOOGLE_AUTH' | translate }}</p>
    <mat-slide-toggle [checked]="userData$?.tfaEnabled" (change)="toggleTFA($event)" class="wm-toggle"></mat-slide-toggle>
  </div>
</div>
